import axios from "axios";

//const API = axios.create({ baseURL: "http://localhost:5001", withCredentials: true });
const API = axios.create({ baseURL: "https://api.themaingategroup.com", withCredentials: true });

export const sendEmails = (emailData, customersToEmail, additional, token) =>
	API.post("/admin/sendemails", { emailData, customersToEmail, additional, token });
